import { useState } from "react";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import {
  Button,
  ButtonVariant,
  IconButton,
  IconButtonSize,
  IconButtonVariant,
  Show
} from "shared/components";
import { Verification } from "shared/types";
import { CombinedIncome } from "shared/app/InviteAndCreateModal/slices/ManualApplication/slices/CombinedIncome";
import {
  CombinedIncomeMode,
  CombinedIncomeStepData
} from "shared/app/InviteAndCreateModal/slices/ManualApplication/slices/CombinedIncome/types";
import { getCombinedIncomeSubStepTitle } from "shared/app/InviteAndCreateModal/slices/ManualApplication/slices/CombinedIncome/utils";
import { useAddIncomeFlow } from "../controller";
import { StepProgress } from "shared/components/StepProgress";

interface Props {
  applicationId: number;
  applicantId: number;
  verification?: Verification;
  refetch: () => void;
  initialStepData?: CombinedIncomeStepData;
  onBack: () => void;
  navigateToReview: (draft: CombinedIncomeStepData) => void;
  onClose: () => void;
}

export const AddIncomeSourceFlow = ({
  applicationId,
  applicantId,
  verification,
  refetch,
  initialStepData,
  onBack,
  navigateToReview,
  onClose
}: Props) => {
  const { stepData, stepDisplayCount, patch, canGoBack, back } =
    useAddIncomeFlow({ verification, initialStepData, navigateToReview });

  const [footerSlot, setFooterSlot] = useState<HTMLElement | null>(null);

  return (
    <div className="flex flex-col">
      <header className="h-[72px] border-b border-alpha-40 flex items-center justify-between px-6">
        <h1 className="font-bold text-xl text-content-1000">
          {getCombinedIncomeSubStepTitle(stepData)}
        </h1>

        <IconButton
          HugeIcon={Cancel01Icon}
          variant={IconButtonVariant.TEXT_BASE}
          size={IconButtonSize.SM}
          onClick={onClose}
        />
      </header>

      <Show if={stepDisplayCount}>
        <StepProgress
          currentStep={stepDisplayCount}
          totalSteps={2}
          className="border-b border-alpha-100 !space-y-1 pt-3 pb-3.5"
        />
      </Show>

      <CombinedIncome
        mode={CombinedIncomeMode.AddNewIncomeSource}
        applicationId={applicationId}
        applicantId={applicantId}
        verification={verification}
        refetchApplication={refetch}
        refetchVerification={refetch}
        stepData={stepData}
        onStepDataChange={patch}
        footerSlot={footerSlot}
      />

      <footer className="space-x-2 flex justify-end py-4 px-6 border-t border-alpha-100">
        <Button
          variant={ButtonVariant.BASE}
          className="w-[125px] mr-2"
          onClick={() => (canGoBack ? back() : onBack())}
        >
          Back
        </Button>

        {/* The active step portals its own footer buttons here, keeping their disabled/loading
            state exactly as the manual application flow would have it. */}
        <div ref={setFooterSlot} className="contents" />
      </footer>
    </div>
  );
};
